import { Box, Card, makeStyles, Typography ,Paper} from '@material-ui/core'
import React from 'react'
import ModalInformativo from '../generales/ModalInformativoStd'
import MapaAlerta  from './MapaAlerta'

const useStyles=makeStyles({
    cardTexto:{
        paddingTop:.125+'rem',
        paddingBottom:.125+'rem',
        textAlign:'center',  
        marginBottom:.5+'rem'      
    },
    texto:{
        fontWeight:700
    },
    cardMapa:{
        display:'flex',
        justifyContent:'center'
    },        

})
const ModalMapa = ({setModalAbierto,modalAbierto,titulo,seleccionado,subtitulo}) => {
    const miClase=useStyles()
    return (
        <ModalInformativo
            setModalAbierto={setModalAbierto} nvoTitulo={seleccionado}
            modalAbierto={modalAbierto} //titulo={titulo}
            tamanio='md' colorFondo='#f5f5f5' subtitulo={subtitulo}
        >
            <Box // style={{width:50+'rem',height:50+'rem'}}
            >
                <Paper elevation={2}>
                <Card style={{marginBottom:.5+'rem'}}>
                {seleccionado.Nombre && seleccionado.Nombre.length!==0 ?
                <span><Typography variant="body2"  color="primary" style={{marginLeft:0.5+'rem',marginRight:1+'rem',fontWeight:700}}>
                    Usuario
                </Typography>
                <Typography variant="body2" >
                    {seleccionado.Nombre}
                </Typography>
                </span>
                :null}
                
                {seleccionado.Observ && seleccionado.Observ.length!==0 ?
                <span>
                    <br/>
                <Typography variant="body2" color="primary" style={{marginLeft:0.5+'rem',marginRight:1+'rem',fontWeight:700}}>
                    Observación
                </Typography>
                <Typography variant="body2" >
                    {seleccionado.Observ}
                </Typography>
                </span>:null}
                </Card>
                </Paper>
                <Paper elevation={2}>
                <Card className={miClase.cardTexto}>
                    <Typography className={miClase.texto}>
                        {seleccionado.Direcc}
                    </Typography>
                </Card>
                </Paper>
                <Card className={miClase.cardMapa}>
                    <MapaAlerta Seleccionado={seleccionado}/>
                </Card>
                
            </Box>
            
        </ModalInformativo>
    )
}

export default ModalMapa
